
// You can write more code here

/* START OF COMPILED CODE */

import PlatformImage from "../PlatformImage";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class PlatformGroundLavaLong extends PlatformImage {

  constructor(scene: Phaser.Scene, x?: number, y?: number, texture?: string, frame?: number | string) {
    super(scene, x ?? 567, y ?? 25.5, texture || 'game-all', frame ?? "platform-lava-long.png");

    // this (prefab fields)
    this.zIndex = 1200;

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  public init() {
    let rect: MatterJS.BodyType = this.scene.matter.bodies.rectangle(this.x, this.y, this.displayWidth, this.displayHeight - 10, {
      render: {
        sprite: {
          xOffset: 0,
          yOffset: 0.05
        }
      }
    });
    // this.customBodies.push(rect);
    this.setExistingBody(rect);
    this.hasCustomBody = true;

    super.init();
  }


  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
